/**
 * Fragebogen.class
 *
 * (c) notwenidges übel UG, Dimitri Preiß (preiss@notwenidges-uebel.de)
 */
import Frage from './frage';

export default class Cheet {
    config = {
        cheetQuestion: '[data-cheet-question]',
    };

    constructor(elem, config) {
        this.config = {...this.config, ...config};
        this.elem = elem;

        this.questions = Array.from(this.elem.querySelectorAll(this.config.cheetQuestion));

        this.questions.forEach((question) => {
            // eslint-disable-next-line no-param-reassign
            question.Question = new Frage(question);
        });
    }

    isComplete() {
        let status = true;
        this.questions.forEach((elem) => {
            if (elem.Question.getStatus() === '') {
                status = false;
            }
        });

        return status;
    }
}
